
export const TEMPLATE_1 = {
  directionType: 3,
  initData: {
    bg: {
      url: "https://appresource.opple.com/media/business/132/20231215094153_76.png",
      width: 100,
      height: 100
    },
    modeType: "TEMPLATE",
    modeData: {
      "0": {
        p: {
          dl: [
            {
              s: "C",
              f: "P",
              r: {
                x: 420,
                y: 30
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 558,
                y: 30
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 558,
                y: 91
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 270,
                y: 91
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 206,
                y: 146
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 556,
                y: 146
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 556,
                y: 199
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 146,
                y: 199
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 100,
                y: 261
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 556,
                y: 261
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 556,
                y: 314
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 66,
                y: 314
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 36,
                y: 382
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 555,
                y: 382
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 555,
                y: 448
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 19,
                y: 448
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 9,
                y: 507
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 555,
                y: 507
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 555,
                y: 562
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 10,
                y: 562
              }
            }
          ],
          m: "L"
        },
        l: {
          m: "SA",
          c: 77,
          l: [
            3,
            5,
            6,
            7,
            8,
            9,
            9,
            10,
            10,
            10
          ]
        }
      },
      "1": {
        p: {
          dl: [
            {
              s: "C",
              f: "P",
              r: {
                x: 612,
                y: 10
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 612,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 671,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 671,
                y: 18
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 726,
                y: 31
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 726,
                y: 565
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 778,
                y: 565
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 778,
                y: 44
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 838,
                y: 70
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 838,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 895,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 895,
                y: 108
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 951,
                y: 148
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 951,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1006,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1006,
                y: 207
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1064,
                y: 298
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1064,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1123,
                y: 566
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1123,
                y: 428
              }
            }
          ],
          m: "L"
        },
        l: {
          m: "SA",
          c: 77,
          l: [
            10,
            10,
            10,
            9,
            9,
            8,
            7,
            6,
            5,
            3
          ]
        }
      },
      "2": {
        p: {
          dl: [
            {
              s: "C",
              f: "P",
              r: {
                x: 24,
                y: 730
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 24,
                y: 613
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 80,
                y: 613
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 80,
                y: 851
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 140,
                y: 931
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 140,
                y: 614
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 199,
                y: 614
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 199,
                y: 991
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 259,
                y: 1041
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 259,
                y: 614
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 316,
                y: 614
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 316,
                y: 1078
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 373,
                y: 1104
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 373,
                y: 614
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 438,
                y: 614
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 438,
                y: 1120
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 492,
                y: 1120
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 492,
                y: 612
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 556,
                y: 612
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 556,
                y: 1121
              }
            }
          ],
          m: "L"
        },
        l: {
          m: "SA",
          c: 77,
          l: [
            3,
            5,
            6,
            7,
            8,
            9,
            9,
            10,
            10,
            10
          ]
        }
      },
      "3": {
        p: {
          dl: [
            {
              s: "C",
              f: "P",
              r: {
                x: 1122,
                y: 619
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 611,
                y: 619
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 611,
                y: 672
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1122,
                y: 672
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1108,
                y: 732
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 613,
                y: 732
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 613,
                y: 787
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1091,
                y: 787
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1061,
                y: 847
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 615,
                y: 847
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 615,
                y: 911
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 1029,
                y: 911
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 992,
                y: 955
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 613,
                y: 955
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 613,
                y: 1009
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 930,
                y: 1009
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 844,
                y: 1066
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 610,
                y: 1066
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 610,
                y: 1124
              }
            },
            {
              s: "C",
              f: "P",
              r: {
                x: 720,
                y: 1124
              }
            }
          ],
          m: "L"
        },
        l: {
          m: "SA",
          c: 77,
          l: [
            10,
            10,
            10,
            9,
            9,
            8,
            7,
            6,
            5,
            3
          ]
        }
      },
    }
  },
  option: {
    light: 255
  }
}